import React from 'react'
import { Link } from 'react-router-dom'
import { LatestArticlesType } from '../../../models/latest-articles-model'

const NewsCardArticle = (props: { article: LatestArticlesType[] }) => {
  const article = props.article
  return (
    <div className="col-sm">
      <div className="feed-single">
        <img src={article[0]?.articleTeaserImage} alt={article[0]?.articleName} loading="lazy" />
        <div className="feed-content">
          <Link to='/news-and-articles'><h5>News</h5></Link>
          <ul>
            {
              (article.length > 1) ? (
                article?.map((item, index) => {
                  return <li key={index}>
                    <Link to={item.articleUrl} dangerouslySetInnerHTML={{ __html: item.articleName }}></Link>
                  </li>
                })

              ) : (
                <li>
                  <Link to={article[0]?.articleUrl} dangerouslySetInnerHTML={{ __html: article[0]?.articleName }}></Link>
                  <p dangerouslySetInnerHTML={{ __html: article[0]?.articleTeaserText }}></p>
                </li>
              )
            }
          </ul>
        </div>
        <div className="Newsrelink"></div>
      </div>
    </div>
  )
}

export default NewsCardArticle
